import React, { useContext, useMemo } from 'react';
import { pick, pipe } from 'ramda';
import { GamesFeaturesContext } from 'js/components/hocs/withGameFeatures';
import { usePortletDispatch, usePortletSelector, usePortletTranslations } from 'js/components/system/Portlet';
import { MultiSelect } from 'js/components/common/Fields/MultiSelect';
import { CATEGORY_TYPE } from '../constants';
import { setFilterCategoriesAction } from './actions';
import { filterByEmptyGames, filterByFeatures, filterByVolatility } from './filters';

export const Categories = () => {
    const features = useContext(GamesFeaturesContext);
    const {
        categories,
        filters: { selectedCategories, selectedFeatures, selectedVolatility }
    } = usePortletSelector(pick(['categories', 'filters']));
    const t = usePortletTranslations();
    const dispatch = usePortletDispatch();

    const filteredCategories = useMemo(
        () => pipe(
            filterByFeatures(selectedFeatures, features),
            filterByVolatility(selectedVolatility, features),
            filterByEmptyGames
        )(categories),
        [features, categories, selectedFeatures, selectedVolatility]
    );

    const options = categories
        .filter(({ cid }) => !(cid === CATEGORY_TYPE.FAVORITES || cid === CATEGORY_TYPE.RECENTLY))
        .map(({ cid: id, displayName }) => {
            const { gameCodes = [] } = filteredCategories.find(cat => cat.cid === id) || {};

            return {
                id,
                label: t(displayName),
                hint: `(${gameCodes.length})`
            };
        });

    const onChange = (selected) => {
        dispatch(setFilterCategoriesAction(selected));
    };

    return (
        <MultiSelect
            label={t('gamesCategories')}
            options={options}
            selected={selectedCategories}
            onChange={onChange}
        />
    );
};

export default Categories;
